module.exports = __webpack_public_path__ + "img/logo.4789a765.png";